export default __webpack_public_path__ + "static/media/03-persona.3d844012.svg";